import { debug } from "util";
angular.module('leanlaw').controller('MatterRatesCtrl', ['$scope', '$state', '$rootScope', '$q', '$filter', "alerts", 'userService', 'reportsService', 'lists', "exportJson", "singleRequest", "messageBus", function ($scope, $state, $rootScope, $q, $filter, alerts, userService, reportsService, lists, exportJson, singleRequest, messageBus) {
  $scope.data = {};
  $scope.filter = {};
  var shortcuts = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filteredClients.reduce((accum, c) => {
      let client = {};
      if ($scope.clientReferences || $scope.references) {
        client = {
          "ID": c.client.reference || "",
          "Client": c.client.name,
          [matter]: ""
        };
      } else {
        client = {
          "Client": c.client.name,
          [matter]: ""
        };
      }
      accum.push(client);
      c.matters.forEach(m => {
        let matterLine = {};
        if ($scope.clientReferences || $scope.references) {
          matterLine = {
            "ID": m.matter.reference ? !isNaN(m.matter.reference) ? `="${m.matter.reference}"` : m.matter.reference : '',
            "Client": "",
            [matter]: m.matter.name
          };
        } else {
          matterLine = {
            "Client": "",
            [matter]: m.matter.name
          };
        }
        if ($scope.me.company.settings?.isRateGroupEnabled) {
          matterLine["Rate Group"] = m.matter.rateGroup?.name;
        }
        matterLine["Responsible"] = m.matter.primary.initials || m.matter.primary.name;
        matterLine["Originating"] = m.originating.join('; ');
        const accounts = m.accounts.filter(a => $scope.data.accountsWithData[a.id]);
        accounts.forEach(a => {
          matterLine[a.name] = a.data ? $filter('amount')(a.data.rates.rate.amount) : '';
        });
        accum.push(matterLine);
      });
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  $scope.openMatter = (client, matter) => {
    return $state.go('matters-next.client.matter', {
      id: client.id,
      matterId: matter.id
    });
  };
  activate();

  ///////////////////

  function activate() {
    // Note: even though we are not using 'me' it should still be loaded to ensure that
    // the lists are updated correctly (me() replaces certain terms in lists.matterRoles)
    $q.all([userService.me(), userService.list()]).then(([me, accounts]) => {
      $scope.me = me;
      $scope.data.accounts = accounts.map(a => ({
        id: a.id,
        name: a.initials || a.name,
        role: a.role
      }));
      $scope.data.roles = lists.matterRoles;
      $scope.data.roles.forEach(role => {
        role.shortcut = role.label[0].toUpperCase();
        shortcuts[role.id] = role.shortcut;
      });
      $scope.$on('commonFilterService-statechanged', (event, payload) => {
        if (!payload) return;
        // Assigning to existing filter keeps custom filter options
        $scope.filter = Object.assign($scope.filter, payload);
        // Necessary to set this value for the requests
        $scope.filter.status = $scope.filter.archived.status;
        $scope.filter.scope = $scope.filter.filter.scope;
        // if (payload.filter.range) filterClientEntries();
        filterClientEntries();
      });
      $scope.$on("report-sidebar-filterchange", (event, payload) => {
        $scope.filter = Object.assign($scope.filter, payload);
      });

      // MessageBus is used here so that the commonFilter module can pick it up once it loads
      messageBus.addMessage("filterDependency-ready", true);
    });
  }
  function filterClientEntries() {
    $scope.loading = true;

    // var query = angular.copy($scope.filter);
    const query = reportsService.queryFromFilter($scope.filter);
    query.data = "rates";
    query.primary = "clients";
    query.secondary = "users";
    singleRequest.serviceCall("reports", reportsService.getReport)(query).then(report => {
      if (!report) return;
      $scope.data.report = report;
      $scope.data.accountsWithData = {};
      $scope.data.clients = report.clients;

      // Filter out internal matters from the report
      $scope.data.clients.forEach(c => {
        c.matters = c.matters.filter(m => m.matter.billing?.type !== 'internal');
      });

      // Filter out clients that have no matters remaining after filtering
      $scope.data.clients = $scope.data.clients.filter(c => c.matters.length > 0);

      // Update the report object to match the filtered clients (for template compatibility)
      $scope.data.report.clients = $scope.data.clients;
      $scope.references = $scope.data.clients.some(c => c.matters.some(m => m.matter.reference));
      $scope.clientReferences = $scope.data.clients.some(c => c.client.reference);
      $scope.data.clients.forEach(c => {
        c.matters.forEach(m => {
          m.accounts = angular.copy($scope.data.accounts);
          m.originating = m.users.filter(u => u.data.rates.originating).map(u => u.user.initials || u.user.name);
          m.users.forEach(u => {
            const account = m.accounts.find(a => a.id === u.user.id);
            if (account && u.data.rates.rate.amount) {
              account.data = u.data;
              $scope.data.accountsWithData[account.id] = true;
            }
          });
        });
      });
      $scope.loading = false;
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("reports");
    deactivate();
  });

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data || !$scope.data.report) return;
    $scope.data.filteredAccounts = $filter('userFilter')($scope.data.accounts, $scope.data.accountsWithData) || [];
    $scope.data.filteredClients = $filter('orderBy')($filter('filter')($scope.data.report.clients, $scope.search), $scope.sort, $scope.reverse) || [];
    $scope.data.filteredClients.forEach(client => {
      client.filteredMatters = $filter('orderBy')(client.matters, $scope.sort, $scope.reverse) || [];
      client.filteredMatters.forEach(matter => {
        matter.filteredAccounts = $filter('userFilter')(matter.accounts, $scope.data.accountsWithData) || [];
      });
    });
  }
  $scope.$watch('data.accounts', updateFiltered);
  $scope.$watch('data.report.clients', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);